import * as Yup from 'yup';
export const validationSchema = Yup.object().shape({
    defaultPaymentMethodId: Yup.string().when('choice', {
        is: (choice) => choice === 'select-new-default',
        then: Yup.string().required(),
    }),
});
